import { Grid, Typography } from '@mui/material';
import { dateTimeValueFormatter } from 'components/AgGrid/gridComponents/helpers';

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  width: '336px',
  mt: 1,
};

interface DocumentCaptureDateProps {
  file: File | null;
}

const DocumentCaptureDate = ({ file }: DocumentCaptureDateProps) => {
  return (
    <Grid container sx={containerStyle} data-testid={'document-capture-date-container'}>
      <Grid container sx={{ mt: 1 }}>
        <Typography variant="body2">Capture date</Typography>
      </Grid>
      {file && (
        <Typography
          variant="body2"
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 0.5,
          }}
        >
          {dateTimeValueFormatter({ value: new Date(file.lastModified).toISOString() })}
        </Typography>
      )}
    </Grid>
  );
};

export default DocumentCaptureDate;
